import { fromPromise } from '../common/rxjs/observable';
import hubfulAuth from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_URL = 'userpreferences/v1/emails/send-as';
export default class API {
  static add(email) {
    return fromPromise(hubfulAuth.post(`${BASE_URL}/${email}`, {
      portalId: PortalIdParser.get()
    }));
  }
  static delete(email) {
    return fromPromise(hubfulAuth.delete(`${BASE_URL}/${email}`, {
      portalId: PortalIdParser.get()
    }));
  }
  static resendVerification(email) {
    return fromPromise(hubfulAuth.post(`${BASE_URL}/${email}/verify/resend`, {
      portalId: PortalIdParser.get()
    }));
  }
}